import type { StructuredContentDocument } from '@cc-shopping/contracts/cross-site/structured-content/types';
import { nullishToUndefinedable } from '@cc-shopping/utils/valibot';
import * as v from 'valibot';

export const featuredMediaSchema = v.object({
  sourceUrl: v.pipe(
    v.string('featuredMedia.sourceUrl must be a string when provided'),
    v.url('featuredMedia.sourceUrl must be a valid URL'),
  ),
  width: v.number('featuredMedia.width is required'),
  height: v.number('featuredMedia.height is required'),
  altText: nullishToUndefinedable(v.string('featuredMedia.altText must be a string when provided')),
  croppedImages: nullishToUndefinedable(
    v.array(
      v.object(
        {
          file: v.string('featuredMedia.croppedImages[number].file is required'),
          height: v.number('featuredMedia.croppedImages[number].height is required'),
          width: v.number('featuredMedia.croppedImages[number].width is required'),
          size: v.string('featuredMedia.croppedImages[number].size is required'),
          sourceUrl: v.string('featuredMedia.croppedImages[number].sourceUrl is required'),
        },
        'featuredMedia.croppedImages[number] must be a valid object',
      ),
      'featuredMedia.croppedImages must be an array of objects',
    ),
  ),
});

export const seoOptionsSchema = v.object({
  title: v.string('seoOptions.title is required'),
  description: v.string('seoOptions.description is required'),
  noindex: v.nullish(v.boolean('seo.noindex must be a boolean when provided'), true),
  nofollow: v.nullish(v.boolean('seo.nofollow must be a boolean when provided'), true),
});

export const structuredContentObjectSchema = v.object({
  type: v.string('structuredContentObject.type is required'),
  version: v.string('structuredContentObject.version is required'),
  props: v.any(),
});

export const structuredContentDocumentSchema = v.custom<StructuredContentDocument>(value => {
  const response = v.safeParse(structuredContentObjectSchema, value);
  if (!response.success) {
    return false;
  }
  return true;
}, 'Invalid structured content document');

const singleSCSchema = v.union(
  [
    nullishToUndefinedable(v.string('singleSC must be a string when provided')),
    structuredContentDocumentSchema,
  ],
  'singleSC must be either a string or structured content document',
);

export const structuredContentSchema = nullishToUndefinedable(
  v.union(
    [
      v.array(singleSCSchema, 'structuredContent must be an array of singleSC items'),
      singleSCSchema,
    ],
    'structuredContent must be either an array or single item',
  ),
);
